import { Trophy, LayoutGrid, Flame, Zap, TrendingUp, TrendingDown, Info, Target } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { Insight } from "./types";

const ICON_MAP: Record<string, React.FC<{ className?: string }>> = {
  trophy: Trophy,
  "layout-grid": LayoutGrid,
  flame: Flame,
  zap: Zap,
  target: Target,
  "trending-up": TrendingUp,
  "trending-down": TrendingDown,
  info: Info,
};

interface Props {
  insights: Insight[];
}

export function Insights({ insights }: Props) {
  if (insights.length === 0) return null;

  return (
    <TooltipProvider delayDuration={0}>
      <div
        className="grid gap-2"
        style={{ gridTemplateColumns: `repeat(${Math.min(insights.length, 4)}, minmax(0, 1fr))` }}
      >
        {insights.map((ins) => {
          const IconComp = ICON_MAP[ins.lucideIcon] ?? Info;
          return (
            <Tooltip key={ins.key}>
              <TooltipTrigger asChild>
                <div className="flex flex-col items-center gap-1.5 rounded-xl bg-secondary/40 px-2 py-3 text-center cursor-default">
                  <IconComp className="h-5 w-5 text-primary/70" />
                  <span className={`font-semibold tabular-nums text-foreground leading-tight ${ins.value.length > 6 ? 'text-xs' : 'text-base'}`}>
                    {ins.value}
                  </span>
                  <span className="text-[11px] leading-tight text-muted-foreground">
                    {ins.label}
                  </span>
                </div>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs max-w-48">
                {ins.detail}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}
